$(document).ready(function(){

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function postToWebhook(formData) {
        $.ajax({
            url: 'https://hook.integromat.com/n13uwysvhcpaatj7h9n8c0ggyp3td621',
            method: 'POST',
            data: formData
        }).done(function(){
            $('#newsletter-subscribe').html('<i class="fas fa-check"></i> Grazie!').attr('disabled', true);
            $('#newsletter-form input[name="email"]').attr('disabled',true);
            $('#newsletter-form input[name="privacyCheck"]').attr('disabled',true);
        });
    }

    $('#newsletter-form').submit(function(e) {
        e.preventDefault();
    });

    $('#privacyCheck').click(function() {
        $("#newsletter-subscribe").attr("disabled", !this.checked);
    });

    $('#newsletter-subscribe').click(function() {
        let email = $('#newsletter-form input[name="email"]').val()
        let privacy = $('#newsletter-form input[name="privacyCheck"]:checked').val()
        let formData = {
            'email': email,
        }
        if (email === '' || validateEmail(email) === false ) {
            alert("Assicurati di aver inserito correttamente l'indirizzo email per favore.");
            return;
        }
        if (privacy === '' || privacy === undefined) {
            alert("E' necessario prestare il consenso al trattamento dei dati accettando l'informativa sulla privacy.");
            return;
        }
        postToWebhook(formData);
    })
    
});